import React from "react";

const  footer = (props) => (
    <footer className="bg-dark text-white text-center p-2">
          © Riadh-NSIRI - 2021
    </footer>
);
export default footer;